export default __webpack_public_path__ + "static/openinfra-usergroup-05ba32f6a517ac92e7257843111391a9.svg";